import { useLang } from '@/app/utils/useLang';
import { FC } from 'react';
import { TimeLine1, TimeLine2, TimeLine3 } from '../../Svg';
import styled from './index.module.scss';
import EditorLink from 'lowcode/components/EditorLink';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import { IPageStatus } from '@/components/MembersDay/type';
import getLocal from '@/app/utils/getLocal';
import { shopnowMay } from '../../constants';

interface IProps {
    type?: string;
}

interface TimeLineItem {
    time: string;
    icon: React.ReactNode;
    title: string;
    title1?: string;
}

const Timeline: FC<IProps> = ({}) => {
    const { t } = useLang('membersday.membersdaytimeline25');
    const { locale } = getLocal();
    const { pageStatus } = useMembersStore();
    const shopnowUrl = shopnowMay[locale] || `https://${locale}.ecoflow.com/pages/members-festival`;

    let list: TimeLineItem[] = [
        {
            time: t('timeline25_list1_time'),
            icon: <TimeLine1 />,
            title: t('timeline25_list1_text'),
        },
        {
            time: t('timeline25_list2_time'),
            icon: <TimeLine2 />,
            title: t('timeline25_list2_text'),
        },
    ];

    if (locale === 'jp') {
        list = [
            {
                time: t('timeline25_list1_time'),
                icon: <TimeLine1 />,
                title: t('timeline25_list1_text'),
            },
            {
                time: t('timeline25_list2_time'),
                icon: <TimeLine2 />,
                title: t('timeline25_list2_text'),
            },
            {
                time: t('timeline25_list3_time'),
                icon: <TimeLine3 />,
                title: t('timeline25_list3_text'),
            },
        ];
    }

    if (['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale)) {
        list = [
            {
                time: t('timeline25_list1_time'),
                icon: <TimeLine1 />,
                title: t('timeline25_list1_text'),
            },
            {
                time: t('timeline25_list2_time'),
                icon: <TimeLine2 />,
                title: t('timeline25_list2_text'),
                title1: t('timeline25_list2_text1'),
            },
        ];
    }

    return (
        <div className={styled.Timeline}>
            <div className="timeline-box">
                <div className="line"></div>
                <div className="box">
                    {list.map((item, index) => (
                        <div className="box-item" key={index}>
                            <p className="item-time">{item.time}</p>
                            <span className="item-point"></span>
                            <div className="item-card">
                                <div className="card-icon">{item.icon}</div>
                                <div className="card-text">
                                    <p className="time">{item.time}</p>
                                    {item.title}
                                    {item.title1 && <p style={{ color: 'red' }}>{item.title1}</p>}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {pageStatus === IPageStatus.ACTIVITY && (
                    <EditorLink
                        className="shopnow-btn"
                        dataLayer={{ event: 'uaEvent', event_name: 'buy', product_name: 'none', position: 'Members-Festival_Power Up the Pool Together' }}
                        href={shopnowUrl}
                        target="_blank"
                    >
                        {t('timeline25_btn')}
                    </EditorLink>
                )}
            </div>
        </div>
    );
};

export default Timeline;
